/* Main */
import { addListener, debounce, fileLoader, toggleGridViewer } from './modules/helpers';
import { menuBuilder, menuOpener, menuCloser } from './modules/menu';
import { init as animations } from './modules/animations';
import Cookies from 'js-cookie';

// Create an SVG Sprite
const appSvgSprite = fileLoader(require.context('../svg/', false, /\.(svg)$/));

// ***************************************
// Menu

// Build the menu based on the number of strips we have.

try {
    const menuItems = menuBuilder(
        document.querySelectorAll('nav[data-strip-navigation]'),
        document.querySelectorAll('section[data-strip]')
    );

    const menuToggle = document.querySelectorAll('.menu-toggle');

    // ...
    addListener('click', menuToggle,
        (event) => document.body.classList.contains('menu--active')
            ? menuCloser(event, menuItems)
            : menuOpener(event, menuItems));

    // Escape key menu close
    addListener('keyup', [document], (event) => {
        if ((event.key === 'Escape' || event.key === 'Esc')
            && document.body.classList.contains('menu--active')) {
            menuCloser(event, menuItems);
        }
    });

    // ...
    let menuOpen = false;

    addListener('focus', document.querySelectorAll('.menu--focus'), (event) => {
        menuOpen = false;
    }, true);

    addListener('blur', document.querySelectorAll('.menu--focus'), (event) => {
        menuOpen = true;

        setTimeout(() => {
            if (menuOpen) {
                menuOpen = false;
                menuCloser(event, menuItems);
            }
        }, 1000);
    }, true);

} catch (error) {
    console.error(error);
}

// ***************************************
// Animations

// Each group of animated sprites is identified by the data
// attribute "data-animation-id" on the respective container element.
animations(document.querySelectorAll('.animation__container'), {
    /*!
        key                             (string)
            sprites[]                   (array)
                sprite                  (object)
                    tweenOptions        (object)
                    > TweenMax
                        pixi            (object)
                        > Pixi
                duration                (number)
                src                     (string)
                offsetX                 (number)
                offsetY                 (number)
    */
    'graphic-map': {
        sprites: [{
            tweenOptions: {
                ease: Sine.easeInOut,
                pixi: {
                    positionX: '+=0.5',
                    positionY: '-=7',
                    rotation: '+=0.2'
                }
            },
            duration: 1,
            src: '/themes/a82a85/dist/images/graphic-map@2x.png',
            offsetX: 0,
            offsetY: 0
        }]
    },
    'graphic-collisions': {
        sprites: [{
            tweenOptions: {
                ease: Sine.easeInOut,
                pixi: {
                    positionX: '-=1',
                    positionY: '+=4',
                    rotation: '+=0.5'
                }
            },
            duration: 1.6,
            src: '/themes/a82a85/dist/images/graphic-performance-sign@2x.png',
            offsetX: 0,
            offsetY: -120
        }, {
            src: '/themes/a82a85/dist/images/graphic-performance-road@2x.png',
            offsetX: 50,
            offsetY: 145
        }, {
            tweenOptions: {
                delay: 2,
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 258
                }
            },
            duration: 7,
            src: '/themes/a82a85/dist/images/graphic-performance-car@2x.png',
            offsetX: -510,
            offsetY: -40
        }, {
            tweenOptions: {
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 245
                }
            },
            duration: 7,
            src: '/themes/a82a85/dist/images/graphic-performance-van@2x.png',
            offsetX: -600,
            offsetY: -75
        }]
    },
    'graphic-camping': {
        sprites: [{
            tweenOptions: {
                ease: Sine.easeInOut,
                pixi: {
                    positionX: '-=1',
                    positionY: '+=2',
                    rotation: '+=0.5'
                }
            },
            duration: 2,
            src: '/themes/a82a85/dist/images/graphic-camping-sign@2x.png',
            offsetX: 150,
            offsetY: -150
        }, {
            tweenOptions: {
                ease: Sine.easeInOut,
                pixi: {
                    positionX: '-=1',
                    positionY: '-=6',
                    rotation: '+=0.5'
                }
            },
            duration: 2,
            src: '/themes/a82a85/dist/images/graphic-camping-island@2x.png',
            offsetX: 0,
            offsetY: 50
        }]
    },
    'graphic-camera': {
        sprites: [{
            tweenOptions: {
                ease: Sine.easeInOut,
                pixi: {
                    positionY: '+=2',
                    rotation: '+=0.1'
                }
            },
            duration: 2,
            src: '/themes/a82a85/dist/images/graphic-camera-sign@2x.png',
            offsetX: 100,
            offsetY: -100
        }, {
            tweenOptions: {
                ease: Sine.easeInOut,
                pixi: {
                    positionX: '-=1',
                    positionY: '-=7',
                    rotation: '+=0.5'
                }
            },
            duration: 2,
            src: '/themes/a82a85/dist/images/graphic-camera-island@2x.png',
            offsetX: 0,
            offsetY: 150
        }]
    },
    'graphic-myth': {
        sprites: [{
            src: '/themes/a82a85/dist/images/graphic-myth-landscape@2x.png',
            offsetX: -100,
            offsetY: 280
        }, {
            tweenOptions: {
                ease: Bounce.easeInOut,
                yoyoEase: true,
                pixi: {
                    positionX: '+=0.5',
                    positionY: '-=0.5',
                    rotation: '+=0.5'
                }
            },
            duration: 0.2,
            src: '/themes/a82a85/dist/images/graphic-myth-car@2x.png',
            offsetX: -150,
            offsetY: 310
        }]
    },
    'graphic-scene-country': {
        sprites: [{
            src: '/themes/a82a85/dist/images/graphic-country-landscape@2x.png',
            offsetX: 380,
            offsetY: 200
        }, {
            tweenOptions: {
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: 500,
                    positionY: -5
                }
            },
            duration: 6,
            src: '/themes/a82a85/dist/images/graphic-country-layer-2@2x.png',
            offsetX: -500,
            offsetY: 265
        }, {
            tweenOptions: {
                delay: 1,
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: 500,
                    positionY: -5
                }
            },
            duration: 6,
            src: '/themes/a82a85/dist/images/graphic-country-layer-4@2x.png',
            offsetX: -500,
            offsetY: 265
        }, {
            tweenOptions: {
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: -600,
                    positionY: 295
                }
            },
            duration: 6,
            src: '/themes/a82a85/dist/images/graphic-country-layer-3@2x.png',
            offsetX: 600,
            offsetY: -25
        }, {
            tweenOptions: {
                delay: 1.6,
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: -600,
                    positionY: 320
                }
            },
            duration: 6,
            src: '/themes/a82a85/dist/images/graphic-country-layer-5@2x.png',
            offsetX: 600,
            offsetY: -5
        }, {
            tweenOptions: {
                delay: 3,
                ease: Sine.easeOut,
                yoyoEase: false,
                pixi: {
                    positionX: -600,
                    positionY: 305
                }
            },
            duration: 6,
            src: '/themes/a82a85/dist/images/graphic-country-layer-6@2x.png',
            offsetX: 600,
            offsetY: -20
        }, {
            src: '/themes/a82a85/dist/images/graphic-country-layer-1@2x.png',
            offsetX: 200,
            offsetY: 120
        }]
    },
    'graphic-scene-bridge': {
        sprites: [{
            // Base Landscape
            src: '/themes/a82a85/dist/images/graphic-bridge-landscape@2x.png',
            offsetX: 0,
            offsetY: 50
        }, {
            // Car 1
            tweenOptions: {
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: -500,
                    positionY: -250
                }
            },
            duration: 7,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-1-4@2x.png',
            offsetX: 800,
            offsetY: 510
        }, {
            // Car 2
            tweenOptions: {
                delay: 1,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: -500,
                    positionY: -250
                }
            },
            duration: 7,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-1-4@2x.png',
            offsetX: 800,
            offsetY: 510
        }, {
            // Lorry 1
            tweenOptions: {
                delay: 2.4,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: -500,
                    positionY: -250
                }
            },
            duration: 7,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-1-3@2x.png',
            offsetX: 800,
            offsetY: 510
        },
        // RIGHT
        {
            // Car 1
            tweenOptions: {
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 300
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-1@2x.png',
            offsetX: -400,
            offsetY: -280
        }, {
            // Lorry 1a
            tweenOptions: {
                delay: 1.6,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 300
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-2@2x.png',
            offsetX: -400,
            offsetY: -282
        }, {
            // Lorry 2
            tweenOptions: {
                delay: 3,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 300
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-3@2x.png',
            offsetX: -400,
            offsetY: -282
        }, {
            // Car 2
            tweenOptions: {
                delay: 4.8,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 298
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-4@2x.png',
            offsetX: -400,
            offsetY: -275
        }, {
            // Car 3
            tweenOptions: {
                delay: 6,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 298
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-5@2x.png',
            offsetX: -400,
            offsetY: -275
        }, {
            // Car 3
            tweenOptions: {
                delay: 7,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 298
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-5@2x.png',
            offsetX: -400,
            offsetY: -275
        }, {
            // Car 4
            tweenOptions: {
                delay: 7.6,
                ease: Sine.ease,
                yoyoEase: false,
                pixi: {
                    positionX: 600,
                    positionY: 328
                }
            },
            duration: 8,
            src: '/themes/a82a85/dist/images/graphic-bridge-layer-2-6@2x.png',
            offsetX: -400,
            offsetY: -250
        }]
    }
});

// ***************************************
// Cookie Control, IS IE11?

window.onload = () => {
    const cookieBanner = document.getElementById('cookie-banner');
    const cookieControl = document.querySelectorAll('.cookie-banner--control');

    if (! Cookies.get('a82a85road-cookie-policy-accepted')) {
        cookieBanner.classList.remove('d-none');
    }

    addListener('click', cookieControl, (event) => {
        event.preventDefault();
        cookieBanner.classList.add('d-none');
        Cookies.set('a82a85road-cookie-policy-accepted', true, { 'expires': 365 });
    });

    // Is IE11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        document.body.classList.add('ie11');
    }
};
